"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionGroupType = exports.DimensionFilterOption = exports.SourceTypeFilterOption = exports.SourceType = exports.CustomQuestionPropertyUnderValidation = exports.SeverityType = exports.PublicationStatusType = exports.PublicationStatus = exports.DimensionType = exports.AttributeName = exports.EditState = exports.QuestionType = exports.SaveProcessingState = exports.SaveAction = void 0;
var SaveAction;
(function (SaveAction) {
    SaveAction[SaveAction["New"] = 1] = "New";
    SaveAction[SaveAction["Edit"] = 2] = "Edit";
    SaveAction[SaveAction["Delete"] = 3] = "Delete";
})(SaveAction = exports.SaveAction || (exports.SaveAction = {}));
var SaveProcessingState;
(function (SaveProcessingState) {
    SaveProcessingState[SaveProcessingState["NotStarted"] = 1] = "NotStarted";
    SaveProcessingState[SaveProcessingState["Processing"] = 2] = "Processing";
    SaveProcessingState[SaveProcessingState["Successful"] = 3] = "Successful";
    SaveProcessingState[SaveProcessingState["Failed"] = 4] = "Failed";
})(SaveProcessingState = exports.SaveProcessingState || (exports.SaveProcessingState = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["Scale"] = 1] = "Scale";
    QuestionType[QuestionType["OpenEnded"] = 2] = "OpenEnded";
    QuestionType[QuestionType["Checkbox"] = 3] = "Checkbox";
    QuestionType[QuestionType["TextBox"] = 4] = "TextBox";
    QuestionType[QuestionType["Slider"] = 5] = "Slider";
    QuestionType[QuestionType["Ranking"] = 6] = "Ranking";
    QuestionType[QuestionType["Hierarchy"] = 7] = "Hierarchy";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var EditState;
(function (EditState) {
    EditState[EditState["None"] = 0] = "None";
    EditState[EditState["Add"] = 1] = "Add";
    EditState[EditState["Update"] = 2] = "Update";
    EditState[EditState["Remove"] = 3] = "Remove";
})(EditState = exports.EditState || (exports.EditState = {}));
var AttributeName;
(function (AttributeName) {
    AttributeName[AttributeName["Dimension"] = 1] = "Dimension";
    AttributeName[AttributeName["AgeRange"] = 2] = "AgeRange";
    AttributeName[AttributeName["Gender"] = 3] = "Gender";
    AttributeName[AttributeName["LevelOfResponsibility"] = 4] = "LevelOfResponsibility";
    AttributeName[AttributeName["Country"] = 5] = "Country";
    AttributeName[AttributeName["Tenure"] = 6] = "Tenure";
    AttributeName[AttributeName["FullTimePartTime"] = 7] = "FullTimePartTime";
    AttributeName[AttributeName["PayBand"] = 8] = "PayBand";
    AttributeName[AttributeName["Region"] = 9] = "Region";
    AttributeName[AttributeName["PeopleManager"] = 10] = "PeopleManager";
    AttributeName[AttributeName["EmploymentType"] = 11] = "EmploymentType";
    AttributeName[AttributeName["JobFunction"] = 12] = "JobFunction";
    AttributeName[AttributeName["FirstCompany"] = 13] = "FirstCompany";
    AttributeName[AttributeName["Generation"] = 14] = "Generation";
    AttributeName[AttributeName["Collar"] = 15] = "Collar";
    AttributeName[AttributeName["BusinessUnit"] = 16] = "BusinessUnit";
    AttributeName[AttributeName["Education"] = 17] = "Education";
    AttributeName[AttributeName["ExpatNational"] = 18] = "ExpatNational";
    AttributeName[AttributeName["ExemptionStatus"] = 19] = "ExemptionStatus";
    AttributeName[AttributeName["EngagementLevel"] = 20] = "EngagementLevel";
    AttributeName[AttributeName["ExternalPersonId"] = 21] = "ExternalPersonId";
    AttributeName[AttributeName["EmployeeSystemId"] = 22] = "EmployeeSystemId";
    AttributeName[AttributeName["LastName"] = 23] = "LastName";
    AttributeName[AttributeName["FirstName"] = 24] = "FirstName";
    AttributeName[AttributeName["MiddleName"] = 25] = "MiddleName";
    AttributeName[AttributeName["FullName"] = 26] = "FullName";
    AttributeName[AttributeName["PreferredName"] = 27] = "PreferredName";
    AttributeName[AttributeName["Email"] = 28] = "Email";
    AttributeName[AttributeName["PersonalEmail"] = 29] = "PersonalEmail";
    AttributeName[AttributeName["CompanyEmail"] = 30] = "CompanyEmail";
    AttributeName[AttributeName["HomeAddress1"] = 31] = "HomeAddress1";
    AttributeName[AttributeName["HomeAddress2"] = 32] = "HomeAddress2";
    AttributeName[AttributeName["HomeAddress3"] = 33] = "HomeAddress3";
    AttributeName[AttributeName["HomeCity"] = 34] = "HomeCity";
    AttributeName[AttributeName["HomeState"] = 35] = "HomeState";
    AttributeName[AttributeName["HomeZip"] = 36] = "HomeZip";
    AttributeName[AttributeName["HomeCounty"] = 37] = "HomeCounty";
    AttributeName[AttributeName["HomeCountry"] = 38] = "HomeCountry";
    AttributeName[AttributeName["OfficeAddress1"] = 39] = "OfficeAddress1";
    AttributeName[AttributeName["OfficeAddress2"] = 40] = "OfficeAddress2";
    AttributeName[AttributeName["OfficeAddress3"] = 41] = "OfficeAddress3";
    AttributeName[AttributeName["OfficeCity"] = 42] = "OfficeCity";
    AttributeName[AttributeName["OfficeState"] = 43] = "OfficeState";
    AttributeName[AttributeName["OfficeZip"] = 44] = "OfficeZip";
    AttributeName[AttributeName["HomePhone"] = 45] = "HomePhone";
    AttributeName[AttributeName["WorkPhone"] = 46] = "WorkPhone";
    AttributeName[AttributeName["CellPhone"] = 47] = "CellPhone";
    AttributeName[AttributeName["ActiveStatus"] = 48] = "ActiveStatus";
    AttributeName[AttributeName["ActiveStatusDescription"] = 49] = "ActiveStatusDescription";
    AttributeName[AttributeName["FulltimeParttimeDescription"] = 50] = "FulltimeParttimeDescription";
    AttributeName[AttributeName["PayType"] = 51] = "PayType";
    AttributeName[AttributeName["EmployerWorkerRelationship"] = 52] = "EmployerWorkerRelationship";
    AttributeName[AttributeName["EmployeeStatusAttribute2"] = 53] = "EmployeeStatusAttribute2";
    AttributeName[AttributeName["EmployeeStatusAttribute3"] = 54] = "EmployeeStatusAttribute3";
    AttributeName[AttributeName["EmployeeStatusAttribute4"] = 55] = "EmployeeStatusAttribute4";
    AttributeName[AttributeName["EmployeeStatusAttribute5"] = 56] = "EmployeeStatusAttribute5";
    AttributeName[AttributeName["EmployeeStatusAttribute6"] = 57] = "EmployeeStatusAttribute6";
    AttributeName[AttributeName["EmployeeStatusAttribute7"] = 58] = "EmployeeStatusAttribute7";
    AttributeName[AttributeName["PositionCode"] = 59] = "PositionCode";
    AttributeName[AttributeName["PositionCodeDescription"] = 60] = "PositionCodeDescription";
    AttributeName[AttributeName["JobCode"] = 61] = "JobCode";
    AttributeName[AttributeName["JobCodeDescription"] = 62] = "JobCodeDescription";
    AttributeName[AttributeName["JobProfileCode"] = 63] = "JobProfileCode";
    AttributeName[AttributeName["JobProfileDescription"] = 64] = "JobProfileDescription";
    AttributeName[AttributeName["JobFamilyCode"] = 65] = "JobFamilyCode";
    AttributeName[AttributeName["JobFamily"] = 66] = "JobFamily";
    AttributeName[AttributeName["JobFamilyGroupCode"] = 67] = "JobFamilyGroupCode";
    AttributeName[AttributeName["JobFamilyGroup"] = 68] = "JobFamilyGroup";
    AttributeName[AttributeName["JobFunctionCode"] = 69] = "JobFunctionCode";
    AttributeName[AttributeName["JobCategoryCode"] = 70] = "JobCategoryCode";
    AttributeName[AttributeName["JobCategory"] = 71] = "JobCategory";
    AttributeName[AttributeName["JobLevel"] = 72] = "JobLevel";
    AttributeName[AttributeName["ManagementLevelCode"] = 73] = "ManagementLevelCode";
    AttributeName[AttributeName["ManagementLevel"] = 74] = "ManagementLevel";
    AttributeName[AttributeName["ShiftCode"] = 75] = "ShiftCode";
    AttributeName[AttributeName["ShiftCodeDescription"] = 76] = "ShiftCodeDescription";
    AttributeName[AttributeName["FLSAStatus"] = 77] = "FLSAStatus";
    AttributeName[AttributeName["PositionAttribute2"] = 78] = "PositionAttribute2";
    AttributeName[AttributeName["PositionAttribute3"] = 79] = "PositionAttribute3";
    AttributeName[AttributeName["PositionAttribute4"] = 80] = "PositionAttribute4";
    AttributeName[AttributeName["PositionAttribute5"] = 81] = "PositionAttribute5";
    AttributeName[AttributeName["PositionAttribute6"] = 82] = "PositionAttribute6";
    AttributeName[AttributeName["PositionAttribute7"] = 83] = "PositionAttribute7";
    AttributeName[AttributeName["PositionAttribute8"] = 84] = "PositionAttribute8";
    AttributeName[AttributeName["PositionAttribute9"] = 85] = "PositionAttribute9";
    AttributeName[AttributeName["PositionAttribute10"] = 86] = "PositionAttribute10";
    AttributeName[AttributeName["TimeInCurrentJob"] = 87] = "TimeInCurrentJob";
    AttributeName[AttributeName["JobEntryDate"] = 88] = "JobEntryDate";
    AttributeName[AttributeName["DirectReportsFlag"] = 89] = "DirectReportsFlag";
    AttributeName[AttributeName["ManagerCode"] = 90] = "ManagerCode";
    AttributeName[AttributeName["ManagerCodeDescription"] = 91] = "ManagerCodeDescription";
    AttributeName[AttributeName["EmployeePositionAttribute3"] = 92] = "EmployeePositionAttribute3";
    AttributeName[AttributeName["EmployeePositionAttribute4"] = 93] = "EmployeePositionAttribute4";
    AttributeName[AttributeName["EmployeePositionAttribute5"] = 94] = "EmployeePositionAttribute5";
    AttributeName[AttributeName["EmployeePositionAttribute6"] = 95] = "EmployeePositionAttribute6";
    AttributeName[AttributeName["EmployeePositionAttribute7"] = 96] = "EmployeePositionAttribute7";
    AttributeName[AttributeName["EmployeePositionAttribute8"] = 97] = "EmployeePositionAttribute8";
    AttributeName[AttributeName["CostCenter"] = 98] = "CostCenter";
    AttributeName[AttributeName["CostCenterDescription"] = 99] = "CostCenterDescription";
    AttributeName[AttributeName["CostCenterParent"] = 100] = "CostCenterParent";
    AttributeName[AttributeName["DepartmentCode"] = 101] = "DepartmentCode";
    AttributeName[AttributeName["DepartmentCodeDescription"] = 102] = "DepartmentCodeDescription";
    AttributeName[AttributeName["BusinessUnitCode"] = 103] = "BusinessUnitCode";
    AttributeName[AttributeName["BusinessGroupCode"] = 104] = "BusinessGroupCode";
    AttributeName[AttributeName["BusinessGroup"] = 105] = "BusinessGroup";
    AttributeName[AttributeName["BusinessDivisionCode"] = 106] = "BusinessDivisionCode";
    AttributeName[AttributeName["BusinessDivision"] = 107] = "BusinessDivision";
    AttributeName[AttributeName["SupervisoryOrganizationId"] = 108] = "SupervisoryOrganizationId";
    AttributeName[AttributeName["SupervisoryOrganization"] = 109] = "SupervisoryOrganization";
    AttributeName[AttributeName["OrganizationId"] = 110] = "OrganizationId";
    AttributeName[AttributeName["OrganizationName"] = 111] = "OrganizationName";
    AttributeName[AttributeName["Company"] = 112] = "Company";
    AttributeName[AttributeName["CompanyDescription"] = 113] = "CompanyDescription";
    AttributeName[AttributeName["OrganizationHierarchy"] = 114] = "OrganizationHierarchy";
    AttributeName[AttributeName["OrganizationLevel1"] = 115] = "OrganizationLevel1";
    AttributeName[AttributeName["OrganizationLevel1Type"] = 116] = "OrganizationLevel1Type";
    AttributeName[AttributeName["OrganizationLevel2"] = 117] = "OrganizationLevel2";
    AttributeName[AttributeName["OrganizationLevel2Type"] = 118] = "OrganizationLevel2Type";
    AttributeName[AttributeName["OrganizationLevel3"] = 119] = "OrganizationLevel3";
    AttributeName[AttributeName["OrganizationLevel3Type"] = 120] = "OrganizationLevel3Type";
    AttributeName[AttributeName["OrganizationLevel4"] = 121] = "OrganizationLevel4";
    AttributeName[AttributeName["OrganizationLevel4Type"] = 122] = "OrganizationLevel4Type";
    AttributeName[AttributeName["OrganizationLevel5"] = 123] = "OrganizationLevel5";
    AttributeName[AttributeName["OrganizationLevel5Type"] = 124] = "OrganizationLevel5Type";
    AttributeName[AttributeName["OrganizationAttribute1"] = 125] = "OrganizationAttribute1";
    AttributeName[AttributeName["OrganizationAttribute2"] = 126] = "OrganizationAttribute2";
    AttributeName[AttributeName["OrganizationAttribute3"] = 127] = "OrganizationAttribute3";
    AttributeName[AttributeName["OrganizationAttribute4"] = 128] = "OrganizationAttribute4";
    AttributeName[AttributeName["OrganizationAttribute5"] = 129] = "OrganizationAttribute5";
    AttributeName[AttributeName["HRPartnerName"] = 130] = "HRPartnerName";
    AttributeName[AttributeName["HRPartnerId"] = 131] = "HRPartnerId";
    AttributeName[AttributeName["HRPartnerEmail"] = 132] = "HRPartnerEmail";
    AttributeName[AttributeName["HRPartnerSupervisorId"] = 133] = "HRPartnerSupervisorId";
    AttributeName[AttributeName["HRPartnerSupervisorName"] = 134] = "HRPartnerSupervisorName";
    AttributeName[AttributeName["HROrganizationAttribute1"] = 135] = "HROrganizationAttribute1";
    AttributeName[AttributeName["HROrganizationAttribute2"] = 136] = "HROrganizationAttribute2";
    AttributeName[AttributeName["HROrganizationAttribute3"] = 137] = "HROrganizationAttribute3";
    AttributeName[AttributeName["HireDate"] = 138] = "HireDate";
    AttributeName[AttributeName["RehireDate"] = 139] = "RehireDate";
    AttributeName[AttributeName["RehireFlag"] = 140] = "RehireFlag";
    AttributeName[AttributeName["DateEligibleToRetire"] = 141] = "DateEligibleToRetire";
    AttributeName[AttributeName["VestingDate"] = 142] = "VestingDate";
    AttributeName[AttributeName["ServiceDate"] = 143] = "ServiceDate";
    AttributeName[AttributeName["EmployeeServiceAttribute1"] = 144] = "EmployeeServiceAttribute1";
    AttributeName[AttributeName["Age"] = 145] = "Age";
    AttributeName[AttributeName["DateOfBirth"] = 146] = "DateOfBirth";
    AttributeName[AttributeName["EthnicDiversityCategory"] = 147] = "EthnicDiversityCategory";
    AttributeName[AttributeName["Ethnicity"] = 148] = "Ethnicity";
    AttributeName[AttributeName["MaritalStatus"] = 149] = "MaritalStatus";
    AttributeName[AttributeName["DemographicAttribute5"] = 150] = "DemographicAttribute5";
    AttributeName[AttributeName["LocationName"] = 151] = "LocationName";
    AttributeName[AttributeName["Building"] = 152] = "Building";
    AttributeName[AttributeName["LocationCountry"] = 153] = "LocationCountry";
    AttributeName[AttributeName["SubRegionCode"] = 154] = "SubRegionCode";
    AttributeName[AttributeName["SubRegionName"] = 155] = "SubRegionName";
    AttributeName[AttributeName["RegionCode"] = 156] = "RegionCode";
    AttributeName[AttributeName["GeographyCode"] = 157] = "GeographyCode";
    AttributeName[AttributeName["GeographyName"] = 158] = "GeographyName";
    AttributeName[AttributeName["LocationAttribute1"] = 159] = "LocationAttribute1";
    AttributeName[AttributeName["LocationAttribute2"] = 160] = "LocationAttribute2";
    AttributeName[AttributeName["LocationAttribute3"] = 161] = "LocationAttribute3";
    AttributeName[AttributeName["LocationAttribute4"] = 162] = "LocationAttribute4";
    AttributeName[AttributeName["ManagerName"] = 163] = "ManagerName";
    AttributeName[AttributeName["ManagerId"] = 164] = "ManagerId";
    AttributeName[AttributeName["ManagerEmail"] = 165] = "ManagerEmail";
    AttributeName[AttributeName["OneOverManagerName"] = 166] = "OneOverManagerName";
    AttributeName[AttributeName["OneOverManagerId"] = 167] = "OneOverManagerId";
    AttributeName[AttributeName["ManagerLevel1Name"] = 168] = "ManagerLevel1Name";
    AttributeName[AttributeName["ManagerLevel2Name"] = 169] = "ManagerLevel2Name";
    AttributeName[AttributeName["ManagerLevel3Name"] = 170] = "ManagerLevel3Name";
    AttributeName[AttributeName["ManagerLevel4Name"] = 171] = "ManagerLevel4Name";
    AttributeName[AttributeName["ManagerLevel5Name"] = 172] = "ManagerLevel5Name";
    AttributeName[AttributeName["ManagerLevel6Name"] = 173] = "ManagerLevel6Name";
    AttributeName[AttributeName["ManagerLevel7Name"] = 174] = "ManagerLevel7Name";
    AttributeName[AttributeName["ManagerLevel8Name"] = 175] = "ManagerLevel8Name";
    AttributeName[AttributeName["ManagerLevel9Name"] = 176] = "ManagerLevel9Name";
    AttributeName[AttributeName["ManagerLevel10Name"] = 177] = "ManagerLevel10Name";
    AttributeName[AttributeName["ManagerLevel1Id"] = 178] = "ManagerLevel1Id";
    AttributeName[AttributeName["ManagerLevel2Id"] = 179] = "ManagerLevel2Id";
    AttributeName[AttributeName["ManagerLevel3Id"] = 180] = "ManagerLevel3Id";
    AttributeName[AttributeName["ManagerLevel4Id"] = 181] = "ManagerLevel4Id";
    AttributeName[AttributeName["ManagerLevel5Id"] = 182] = "ManagerLevel5Id";
    AttributeName[AttributeName["ManagerLevel6Id"] = 183] = "ManagerLevel6Id";
    AttributeName[AttributeName["ManagerLevel7Id"] = 184] = "ManagerLevel7Id";
    AttributeName[AttributeName["ManagerLevel8Id"] = 185] = "ManagerLevel8Id";
    AttributeName[AttributeName["ManagerLevel9Id"] = 186] = "ManagerLevel9Id";
    AttributeName[AttributeName["ManagerLevel10Id"] = 187] = "ManagerLevel10Id";
    AttributeName[AttributeName["ManagerPath"] = 188] = "ManagerPath";
    AttributeName[AttributeName["GraphHierarchy1Id"] = 189] = "GraphHierarchy1Id";
    AttributeName[AttributeName["GraphHierarchy1Name"] = 190] = "GraphHierarchy1Name";
    AttributeName[AttributeName["GraphHierarchy2Id"] = 191] = "GraphHierarchy2Id";
    AttributeName[AttributeName["GraphHierarchy2Name"] = 192] = "GraphHierarchy2Name";
    AttributeName[AttributeName["GraphHierarchy3Id"] = 193] = "GraphHierarchy3Id";
    AttributeName[AttributeName["GraphHierarchy3Name"] = 194] = "GraphHierarchy3Name";
    AttributeName[AttributeName["PerformanceRatingLabel"] = 195] = "PerformanceRatingLabel";
    AttributeName[AttributeName["PerformanceRatingValue"] = 196] = "PerformanceRatingValue";
    AttributeName[AttributeName["PerformanceReviewDate"] = 197] = "PerformanceReviewDate";
    AttributeName[AttributeName["PotentialRatingLabel"] = 198] = "PotentialRatingLabel";
    AttributeName[AttributeName["PotentialRatingValue"] = 199] = "PotentialRatingValue";
    AttributeName[AttributeName["PotentialRatingDate"] = 200] = "PotentialRatingDate";
    AttributeName[AttributeName["NineBoxLabel"] = 201] = "NineBoxLabel";
    AttributeName[AttributeName["NineBoxValue"] = 202] = "NineBoxValue";
    AttributeName[AttributeName["NineBoxEffectiveDate"] = 203] = "NineBoxEffectiveDate";
    AttributeName[AttributeName["PerformanceAttribute1"] = 204] = "PerformanceAttribute1";
    AttributeName[AttributeName["PerformanceAttribute2"] = 205] = "PerformanceAttribute2";
    AttributeName[AttributeName["PerformanceAttribute3"] = 206] = "PerformanceAttribute3";
    AttributeName[AttributeName["TerminationDate"] = 207] = "TerminationDate";
    AttributeName[AttributeName["TerminationType"] = 208] = "TerminationType";
    AttributeName[AttributeName["TerminationReason"] = 209] = "TerminationReason";
    AttributeName[AttributeName["TerminationReason2"] = 210] = "TerminationReason2";
    AttributeName[AttributeName["VoluntaryFlag"] = 211] = "VoluntaryFlag";
    AttributeName[AttributeName["SalaryWage"] = 212] = "SalaryWage";
    AttributeName[AttributeName["CompensationRatio"] = 213] = "CompensationRatio";
    AttributeName[AttributeName["LastMeritAmount"] = 214] = "LastMeritAmount";
    AttributeName[AttributeName["LastMeritDate"] = 215] = "LastMeritDate";
    AttributeName[AttributeName["LastSalaryIncreaseAmount"] = 216] = "LastSalaryIncreaseAmount";
    AttributeName[AttributeName["LastSalaryIncreasePercent"] = 217] = "LastSalaryIncreasePercent";
    AttributeName[AttributeName["LastSalaryIncreaseDate"] = 218] = "LastSalaryIncreaseDate";
    AttributeName[AttributeName["CurrencyCode"] = 219] = "CurrencyCode";
    AttributeName[AttributeName["CompensationAttribute1"] = 220] = "CompensationAttribute1";
    AttributeName[AttributeName["CompensationAttribute2"] = 221] = "CompensationAttribute2";
    AttributeName[AttributeName["MSEngagementLevel"] = 222] = "MSEngagementLevel";
    AttributeName[AttributeName["HierarchyPositionAttribute1"] = 223] = "HierarchyPositionAttribute1";
    AttributeName[AttributeName["HierarchyLocationAttribute1"] = 224] = "HierarchyLocationAttribute1";
    AttributeName[AttributeName["HierarchyFunctionAttribute1"] = 225] = "HierarchyFunctionAttribute1";
    AttributeName[AttributeName["HierarchyBusinessUnitAttribute1"] = 226] = "HierarchyBusinessUnitAttribute1";
    AttributeName[AttributeName["HierarchyHybridAttribute1"] = 227] = "HierarchyHybridAttribute1";
    AttributeName[AttributeName["HierarchyOtherAttribute1"] = 228] = "HierarchyOtherAttribute1";
    AttributeName[AttributeName["HierarchyManagerialAttribute1"] = 229] = "HierarchyManagerialAttribute1";
})(AttributeName = exports.AttributeName || (exports.AttributeName = {}));
var DimensionType;
(function (DimensionType) {
    DimensionType[DimensionType["Dimension"] = 1] = "Dimension";
    DimensionType[DimensionType["Index"] = 2] = "Index";
})(DimensionType = exports.DimensionType || (exports.DimensionType = {}));
var PublicationStatus;
(function (PublicationStatus) {
    PublicationStatus["Draft"] = "Draft";
    PublicationStatus["Public"] = "Public";
    PublicationStatus["Inactive"] = "Inactive";
})(PublicationStatus = exports.PublicationStatus || (exports.PublicationStatus = {}));
var PublicationStatusType;
(function (PublicationStatusType) {
    PublicationStatusType[PublicationStatusType["Draft"] = 1] = "Draft";
    PublicationStatusType[PublicationStatusType["Public"] = 2] = "Public";
    PublicationStatusType[PublicationStatusType["Inactive"] = 3] = "Inactive";
})(PublicationStatusType = exports.PublicationStatusType || (exports.PublicationStatusType = {}));
var SeverityType;
(function (SeverityType) {
    SeverityType[SeverityType["Error"] = 0] = "Error";
    SeverityType[SeverityType["Warning"] = 1] = "Warning";
})(SeverityType = exports.SeverityType || (exports.SeverityType = {}));
var CustomQuestionPropertyUnderValidation;
(function (CustomQuestionPropertyUnderValidation) {
    CustomQuestionPropertyUnderValidation["code"] = "Code";
    CustomQuestionPropertyUnderValidation["text"] = "Text";
    CustomQuestionPropertyUnderValidation["questionText"] = "QuestionText";
    CustomQuestionPropertyUnderValidation["responseOptions"] = "ResponseOptions";
    CustomQuestionPropertyUnderValidation["attributeName"] = "AttributeName";
    CustomQuestionPropertyUnderValidation["responseOptionGroupName"] = "Name";
    CustomQuestionPropertyUnderValidation["responseOptionLabel"] = "ResponseOptions.Name";
    CustomQuestionPropertyUnderValidation["responseOptionValue"] = "ResponseOptions.Value";
})(CustomQuestionPropertyUnderValidation = exports.CustomQuestionPropertyUnderValidation || (exports.CustomQuestionPropertyUnderValidation = {}));
var SourceType;
(function (SourceType) {
    SourceType[SourceType["KincentricLibrary"] = 1] = "KincentricLibrary";
    SourceType[SourceType["ClientLibrary"] = 2] = "ClientLibrary";
    SourceType[SourceType["Custom"] = 3] = "Custom";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var SourceTypeFilterOption;
(function (SourceTypeFilterOption) {
    SourceTypeFilterOption["AllQuestions"] = "All";
    SourceTypeFilterOption["KincentricSurveyQuestion"] = "Library1";
    SourceTypeFilterOption["KincentricDemographicQuestion"] = "Library2";
    SourceTypeFilterOption["ClientSurveyQuestion"] = "Custom1";
    SourceTypeFilterOption["ClientDemographicQuestion"] = "Custom2";
})(SourceTypeFilterOption = exports.SourceTypeFilterOption || (exports.SourceTypeFilterOption = {}));
var DimensionFilterOption;
(function (DimensionFilterOption) {
    DimensionFilterOption["AllDimensionsIndices"] = "1";
    DimensionFilterOption["KincentricDimensions"] = "2";
    DimensionFilterOption["KincentricIndices"] = "3";
    DimensionFilterOption["ClientDimensions"] = "4";
    DimensionFilterOption["ClientIndices"] = "5";
})(DimensionFilterOption = exports.DimensionFilterOption || (exports.DimensionFilterOption = {}));
var ResponseOptionGroupType;
(function (ResponseOptionGroupType) {
    ResponseOptionGroupType[ResponseOptionGroupType["ElevenPointGroup"] = 1] = "ElevenPointGroup";
    ResponseOptionGroupType[ResponseOptionGroupType["SixPointGroup"] = 2] = "SixPointGroup";
    ResponseOptionGroupType[ResponseOptionGroupType["TwoPointGroup"] = 3] = "TwoPointGroup";
    ResponseOptionGroupType[ResponseOptionGroupType["Comment"] = 4] = "Comment";
    ResponseOptionGroupType[ResponseOptionGroupType["Demographic"] = 5] = "Demographic";
    ResponseOptionGroupType[ResponseOptionGroupType["FivePointGroup"] = 6] = "FivePointGroup";
    ResponseOptionGroupType[ResponseOptionGroupType["ThreePointGroup"] = 7] = "ThreePointGroup";
    ResponseOptionGroupType[ResponseOptionGroupType["Dimension"] = 8] = "Dimension";
    ResponseOptionGroupType[ResponseOptionGroupType["Hierarchy"] = 9] = "Hierarchy";
})(ResponseOptionGroupType = exports.ResponseOptionGroupType || (exports.ResponseOptionGroupType = {}));
